import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";
import Card from "../ui/Card";
import SectionTitle from "../ui/SectionTitle";

export default function Projects() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14" id="projects">
      <SectionTitle title="Featured Projects" />

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {DATA.projects.map((p) => (
          <Card
            key={p.title}
            className="transition hover:border-white/20 hover:bg-white/[0.07]"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="text-lg font-semibold text-white">
                  {p.title}
                </div>
                <div className="mt-1 text-xs text-indigo-300/80">{p.tag}</div>
              </div>
            </div>

            <p className="mt-3 text-white/70">{p.desc}</p>

            <ul className="mt-4 space-y-2 text-sm text-white/70">
              {p.bullets.map((b) => (
                <li key={b} className="flex gap-2">
                  <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-indigo-400/80" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            {/* optional buttons (hook for future links) */}
            {/* <div className="mt-5 flex flex-wrap gap-2">
              <button className="rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-xs text-white hover:bg-white/10">
                demo / video
              </button>
            </div> */}
          </Card>
        ))}
      </div>
    </div>
  );
}
